export const colorWarmGray = "rgb(87, 79, 74)";
export const colorBlack = "rgb(0, 0, 0)";
export const colorSocialPinterest = "rgb(203, 32, 40)";
export const colorGreen = "rgb(115, 196, 143)";
export const colorLightGray = "rgb(246, 246, 246)";
export const colorOrange = "rgb(250, 164, 26)";
export const colorWhite = "rgb(255, 255, 255)";
export const colorSocialGoogle = "rgb(221, 75, 57)";
export const colorYellow = "rgb(255, 206, 81)";
export const colorDarkGray = "rgb(64, 64, 64)";
export const colorMediumGray = "rgb(166, 166, 166)";
export const colorRed = "rgb(241, 93, 34)";
export const colorBlue = "rgb(72, 185, 199)";
export const colorPurple = "rgb(51, 10, 36)";
export const colorSocialGithub = "rgb(0, 0, 0)";
export const colorSocialFacebook = "rgb(59, 87, 157)";
export const colorSocialInstagram = "rgb(255, 185, 0)";
export const colorSocialUbuntu = "rgb(48, 10, 36)";
export const colorSocialTwitter = "rgb(0, 182, 241)";
export const fontFamilySans = ["Fira Sans","system-ui","-apple-system","Segoe UI","Roboto","Ubuntu","Cantarell","Nato Sans","sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"];
export const fontFamilySlab = ["Roboto Slab","serif"];
export const fontFamilyMono = ["Ubuntu Mono","Ubuntu Monospace","Menlo","Consolas","Roboto Mono","Noto Mono","Oxygen Mono","Liberation Mono","monospace"];
export const lineHeight = 1.5;
export const boxShadowLightAction = ["0 0 8px rgba(250, 164, 26, 0.7)","0 0 1px rgba(250, 164, 26, 0.7)"];